import request from "@/http/request"
import {
    getClassList,
    setStudentClass,
    getClassStudentList,
    exportStudent,
    getStudentViewInfo,
    publishPlanClass,
    getDeskTitleContent,
    querySignSessionList,
    querySignPlaceList,
    querySignClassList,
    getBatchSignTable,
    getPlanAllSession,
    getPlanPlaceList,
    createSignTable,
    getPlanAllSessionByPlanId,
    getPlaceSessionClassCount,
    exportClassRoomTitle,
    getClassesByPlanSessionPlace,
    getPlanPlaceSessionClass,
    exportExamOrderCode,
    getFileDeskTitle,
    judgeImportArrangeClassInfo,
    importArrangeClassInfo,
    getPreGeneratedAnswerPaper,
    downloadPreGeneratedAnswerPaper,
    exportEntrance,
    getSubjectListByPlanId,
    getSystemDefaultRule,
    getCustomRuleByPlanId,
    saveCustomRuleByPlanId,
    entranceExportTemplate,
    entranceImport,
    entranceImportDataList,
    getSubjectListByPlanIdCert,
    getSystemDefaultRuleCert,
    getCustomRuleByPlanIdCert,
    saveCustomRuleByPlanIdCert,
    certificateExportTemplate,
    certificateImport,
    certificateImportDataList
} from '@/http/api'


export const getSubjectListByPlanIdAPI = (data) => {
    return request({
        url: getSubjectListByPlanId,
        data
    })
}

export const getSystemDefaultRuleAPI = (data) => {
    return request({
        url: getSystemDefaultRule,
        data
    })
}

export const getCustomRuleByPlanIdAPI = (data) => {
    return request({
        url: getCustomRuleByPlanId,
        data
    })
}
export const saveCustomRuleByPlanIdAPI = (data) => {
    return request({
        url: saveCustomRuleByPlanId,
        data
    })
}

export const entranceExportTemplateAPI = (data) => {
    return request({
        url: entranceExportTemplate,
        data
    })
}

export const entranceImportAPI = (data) => { 
    return request({
        url: entranceImport,
        isUpload:true,
        data
    })
}

export const entranceImportDataListAPI = (data) => {
    return request({
        url: entranceImportDataList,
        data
    })
}

export const getSubjectListByPlanIdCertAPI = (data) => {
    return request({
        url: getSubjectListByPlanIdCert,
        data
    })
}

export const getSystemDefaultRuleCertAPI = (data) => {
    return request({
        url: getSystemDefaultRuleCert,
        data
    })
}

export const getCustomRuleByPlanIdCertAPI = (data) => {
    return request({
        url: getCustomRuleByPlanIdCert,
        data
    })
}

export const saveCustomRuleByPlanIdCertAPI = (data) => {
    return request({
        url: saveCustomRuleByPlanIdCert,
        data
    })
}

export const certificateExportTemplateAPI = (data) => {
    return request({
        url: certificateExportTemplate,
        data
    })
}

export const certificateImportAPI = (data) => {
    return request({
        url: certificateImport,
        isUpload:true,
        data
    })
}

export const certificateImportDataListAPI = (data) => {
    return request({
        url: certificateImportDataList,
        data
    })
}


export const importArrangeClassInfoAPI = (data) => {
    return request({
        url: importArrangeClassInfo,
        isUpload:true,
        data
    })
}

export const downloadPreGeneratedAnswerPaperAPI = (data) => {
    return request({
        url: downloadPreGeneratedAnswerPaper,
        data
    })
}

export const getPreGeneratedAnswerPaperAPI = (data) => {
    return request({
        url: getPreGeneratedAnswerPaper,
        data
    })
}

export const judgeImportArrangeClassInfoAPI = (data) => {
    return request({
        url: judgeImportArrangeClassInfo,
        data
    })
}

export const getFileDeskTitleApi = (data) => {
    return request({
        url: getFileDeskTitle,
        data
    })
}

export const exportClassRoom = (data) => {
    return request({
        url: exportClassRoomTitle,
        data
    })
}

export const getClassListFn = (data) => {
    return request({
        url: getClassList,
        data
    })
}

export const setStudentClassFn = (data) => {
    return request({
        url: setStudentClass,
        data
    })
}

export const getClassStudentListFn = (data) => {
    return request({
        url: getClassStudentList,
        data
    })
}

export const exportStudentFn = (data) => {
    return request({
        url: exportStudent,
        data
    })
}

export const getStudentViewInfoFn = (data) => {
    return request({
        url: getStudentViewInfo,
        data
    })
}

export const publishPlanClassFn = (data) => {
    return request({
        url: publishPlanClass,
        data
    })
}

export const getDeskTitleContentFn = (data) => {
    return request({
        url: getDeskTitleContent,
        data
    })
}

export const getPlaceSessionClassCountFN = (data) => {
    return request({
        url: getPlaceSessionClassCount,
        data
    })
}

export const getSignSessionList = (data) => {
    return request({
        url: querySignSessionList,
        data
    })
}
export const getSignPlaceList = (data) => {
    return request({
        url: querySignPlaceList,
        data
    })
}
export const getSignClassList = (data) => {
    return request({
        url: querySignClassList,
        data
    })
}
export const exportSign = (data) => {
    return request({
        url: getBatchSignTable,
        data
    })
}
export const getCurrentSelectSection = (data) => {
    return request({
        url: getPlanAllSession,
        data
    })
}
export const getCurrentSelectPlace = (data) => {
    return request({
        url: getPlanPlaceList,
        data
    })
}

export const getPlanAllSessionByPlan = (data) => {
    return request({
        url: getPlanAllSessionByPlanId,
        data
    })
}
export const openSignTable = (data) => {
    return request({
        url: createSignTable,
        data
    })
}
export const  getClassesByPlanSessionPlaceFn= (data) => {
    return request({
        url: getClassesByPlanSessionPlace,
        data
    })
}
export const  getPlanPlaceSessionClassFn= (data) => {
    return request({
        url: getPlanPlaceSessionClass,
        data
    })
}
export const  exportExamOrderexcel= (data) => {
    return request({
        url: exportExamOrderCode,
        data
    })
}
export const  exportEntranceFn= (data) => {
    return request({
        url: exportEntrance,
        data
    })
}